export default {
    attachment: "/gateway/huilianApi/uploader/attachment", // 图片上传

    h5: {
        sendCertificateCode:
            "/gateway/huilianCust/realCustcs/sendCertificateCode", // 上上签验证码
    },
    wechat: {
        sendCertificateCode:
            "/gateway/huilianCust/realCustcs/sendCertificateCode", // 上上签验证码
    },
};



// WEBPACK FOOTER //
// ./src/authCertificate/modules/attestationType/api.js